// import AssistiveTechnology from "./assets/1.png";
import E_Sport from "./assets/E-Sport 2.png";
import SupplyChainlogistics from "./assets/Supply Chain & logistics.png";
import DigitalMarketing from "./assets/Digital Marketing 2.png";
import IT from "./assets/it (3).png";
import PR from "./assets/images/PR 1.png";
import CYS from "./assets/images/Cybersecurity.png";
import QNTM from "./assets/it (3).png";
// import Sustainability from "./assets/5.png";

const CommunitiesData = [
  {
    id: 1,
    image: E_Sport,
    title: "ByTechS eSports",
    titleAr: "مجتمع الرياضات الإلكترونية",
    distinctive:
      "A community that combines e-sports and technical development to enhance skills in gaming and teamwork. Also, it provides an environment that blends passion for gaming with the development of technical and managerial skills.",
    distinctiveAr:
      " مجتمع يجمع بين الرياضات الإلكترونية والتطوير التقني لتطوير المهارات في الألعاب والعمل الجماعي. ويوفر بيئة تجمع بين شغف الألعاب وتنمية المهارات التقنية والإدارية.",
    objective:
      "to empower talented individuals in e-sports to participate in professional tournaments while developing them technically and personally.",
    objectiveAr:
      "تمكين الموهوبين في الرياضات الإلكترونية من المشاركة في بطولات احترافية مع تطويرهم تقنيًا وشخصيًا.",
    vision:
      "To become a leading community in the Middle East that supports e-sports enthusiasts locally and internationally.",
    visionAr:
      "أن نصبح مجتمعًا رائدًا في الشرق الأوسط يدعم محبي الرياضات الإلكترونية محليًا ودوليًا.",
    whyUs: [
      "Develop technical and leadership skills.",
      "Connect with industry experts and professionals.",
      "Represent the community in global tournaments.",
      "Enjoy enriching and fun activities.",
      "Gain experience in team organization and management.",
    ],
    whyUsAr: [
      " تطوير مهارات تقنية وقيادية.",
      " التواصل مع خبراء ومحترفي المجال",
      "تمثيل المجتمع في بطولات عالمية.",
      " تجربة أنشطة ممتعة ومثرية.",
      " اكتساب خبرات في تنظيم الفرق وإدارتها.",
    ],
    audience:
      "e-sports enthusiasts of all levels, including players, developers, and team organizers.",
    audienceAr:
      "محبي الألعاب الإلكترونية بمختلف المستويات، من لاعبين إلى مطورين ومنظمي فرق.",
    activities: [
      "Sports Tournaments: Organizing local and regional competitions.",
      "Technical Workshops: For programming, design, and building gameplay strategies.",
      "Training: Sessions to analyze performance and improve tactics.",
      "Networking: Meetups with industry experts and gaming companies.",
      "Content Management: Producing and broadcasting professional e-sports content.",
    ],
    activitiesAr: [
      " بطولات رياضية: تنظيم منافسات محلية وإقليمية.",
      " ورش تقنية: لتطوير البرمجة والتصميم وبناء استراتيجيات اللعب.",
      "تدريب: جلسات لتحليل الأداء وتحسين التكتيكات.",
      "تواصل: لقاءات مع خبراء الصناعة وشركات الألعاب.",
      " إدارة محتوى: إنتاج وبث محتوى احترافي يتعلق بالرياضات الإلكترونية.",
    ],
    structure: [
      "Community Leader: Responsible for the overall vision.",
      "Activity Manager: Organizes events and competitions.",
      "Development Specialist: Supports players' performance improvement.",
      "Public Relations: Builds partnerships with supporting companies.",
      "Core Members: Players and contributors in organization and management.",
    ],
    structureAr: [
      "قائد المجتمع: مسؤول عن الرؤية العامة.",
      " مدير الأنشطة: ينظم الفعاليات والمسابقات.",
      "مسؤول تطوير: يدعم تحسين أداء اللاعبين.",
      "العلاقات العامة: يبني شراكات مع الشركات الداعمة",
      " الأعضاء الأساسيون: لاعبين ومساهمين في التنظيم والإدارة.",
    ],
  },
  {
    id: 2,
    image: SupplyChainlogistics,
    title: "ByTechS Supply Chain & Logistics",
    titleAr: "مجتمع سلاسل الإمداد واللوجستيات",
    distinctive:
      "Focuses on empowering members through hands-on workshops and innovative programs. Provides awareness opportunities to apply and transfer knowledge to the community.",
    distinctiveAr:
      "يركز على تمكين الأعضاء عبر ورش عمل عملية وبرامج مبتكرة. ويقدم فرص توعية لتطبيق المعرفة ونقلها للمجتمع.",
    objective:
      "To educate the community and enhance its skills in supply chain and logistics.",
    objectiveAr:
      "تثقيف المجتمع وتطوير مهاراته في سلاسل الإمداد والخدمات اللوجستية.",
    vision:
      "To lead in spreading knowledge and advancing the supply chain and logistics sector.",
    visionAr:
      "الريادة في نشر المعرفة وتنمية قطاع سلاسل الإمداد والخدمات اللوجستية.",
    whyUs: [
      "Gain practical skills.",
      "Learn from industry experts.",
      "Participate in enjoyable activities and build professional connections.",
    ],
    whyUsAr: [
      "اكتساب مهارات عملية.",
      "التعلم من خبراء المجال.",
      "المشاركة في أنشطة ممتعة وبناء علاقات مهنية.",
    ],
    audience:
      "High school students and enthusiasts from non-specialized fields.",
    audienceAr: "طلاب الثانوية والمهتمون من غير المتخصصين في المجال.",
    activities: [
      "Scientific newsletters and innovative workshops.",
      "Seminars and competitions simulating real-world challenges.",
      "Training sessions and applied projects.",
    ],
    activitiesAr: [
      "نشرات علمية وورش عمل مبتكرة.",
      "ندوات ومسابقات تحاكي تحديات واقعية.",
      "جلسات تدريب ومشاريع تطبيقية.",
    ],
    structure: [
      "Community Leader: Manages the community and guides initiatives.",
      "Activity Coordinator: Responsible for events.",
      "Team Members: Support implementation and initiatives.",
    ],
    structureAr: [
      "قائد المجتمع: يدير المجتمع ويوجه المبادرات.",
      "منسق الأنشطة: مسؤول عن الفعاليات.",
      "أعضاء الفريق: يدعمون التنفيذ والمبادرات.",
    ],
  },
  {
    id: 3,
    image: DigitalMarketing,
    title: "Digital Marketing",
    titleAr: "مجتمع التسويق الرقمي",
    distinctive:
      "Empowering those interested in digital marketing with the latest skills and strategies. Also, Supporting beginners by providing a solid foundation to enter the field",
    distinctiveAr:
      "تمكين المهتمين بالتسويق الرقمي عبر أحدث المهارات والاستراتيجيات. ودعم المبتدئين بتوفير أساس قوي لدخول المجال.",
    objective:
      "To provide a dynamic environment for knowledge and experience exchange in digital marketing and to develop members' skills.",
    objectiveAr:
      "أن نصبح الوجهة الأولى للأفراد والشركات لاعتماد أحدث تقنيات التسويق الرقمي عالميًا ومحليًا.",
    vision:
      "To become the top destination for individuals and businesses to adopt the latest digital marketing techniques globally and locally.",
    visionAr:
      "أن نصبح الوجهة الأولى للأفراد والشركات لاعتماد أحدث تقنيات التسويق الرقمي عالميًا ومحليًا.",
    whyUs: [
      "Learn from experts in digital marketing.",
      "Exchange ideas and experiences with enthusiasts.",
      "Stay updated on the latest industry trends.",
      "Build a strong professional network.",
    ],
    whyUsAr: [
      "تعلم من الخبراء في التسويق الرقمي.",
      "تبادل الأفكار والتجارب مع المهتمين.",
      "التعرف على أحدث تطورات المجال.",
      "بناء شبكة علاقات مهنية قوية",
    ],
    audience:
      "Digital marketing enthusiasts, Specialists entrepreneurs, project owners and companies.",
    audienceAr:
      "المهتمين بالتسويق الرقمي، والمتخصصون وروّاد الأعمال، وأصحاب المشاريع والشركات",
    activities: [
      "Discussion sessions with experts.",
      "Specialized training workshops.",
      "Strategic partnerships and collaborations.",
    ],
    activitiesAr: [
      "جلسات حوارية مع الخبراء.",
      "ورش عمل تدريبية متخصصة.",
      "شراكات وتعاونات استراتيجية.",
    ],
    structure: [
      "Founding Members: Maryam Al-Muzail, Reem Al-Qasem.",
      "Operational Members: Haya Al-Khalidi",
    ],
    structureAr: [
      "الأعضاء المؤسسون: مريم المزعل، ريم القاسم.",
      "الأعضاء التشغيليين: هيا الخالدي",
    ],
  },
  {
    id: 4,
    image: IT,
    title: "ByTechS IT Department",
    titleAr: "قسم تقنية المعلومات",
    distinctive:
      "A specialized team in developing innovative technical solutions that meet ByTechS's needs, and maintaining and continuously updating ByTechS's digital platforms.",
    distinctiveAr:
      "فريق متخصص في تطوير الحلول التقنية المبتكرة التي تلبي احتياجات بايتكس، إضافةً إلى صيانة وتحديث منصات بايتكس الرقمية بشكل مستمر.",
    objective:
      "Enhance the technical efficiency of the initiative by providing innovative digital solutions that support development through investing in young talents and developing technical solutions that support ByTechS projects' sustainability and strengthen their presence.",
    objectiveAr:
      "تعزيز الكفاءة التقنية للمبادرة من خلال تقديم حلول رقمية مبتكرة تدعم التطور بالاستثمار في الكفاءات الشابة وتطوير الحلول التقنية التي تدعم استدامة مشاريع بايتكس وتعزز تواجدها.",
    vision:
      "For the technical team to become a pioneering model in providing integrated technical solutions that reflect the values of innovation and creativity and support ByTechS's future aspirations.",
    visionAr:
      "أن يصبح الفريق التقني نموذجًا رياديًا في تقديم حلول تقنية متكاملة تعكس قيم الابتكار والإبداع وتدعم تطلعات بايتكس المستقبلية.",
    whyUs: [
      "Skill development through advanced practical experience in technical fields.",
      "Working in a team characterized by a spirit of giving and passion for achievement.",
      "Participating in pioneering and inspiring technical projects.",
      "Continuous learning that contributes to skill enhancement.",
    ],
    whyUsAr: [
      "تطوير المهارات باكتساب خبرات عملية متقدمة في المجالات التقنية.",
      "العمل في فريق يتسم بروح العطاء وشغف الإنجاز.",
      "المشاركة في مشاريع تقنية ريادية وملهمة.",
      "التعلم المستمر الذي يسهم في تعزيز المهارات.",
    ],
    audience:
      "Targeting young talented developers and computer specialists to provide opportunities for gaining practical experience and developing their skills.",
    audienceAr:
      "استهداف الكفاءات الشابة من المطورين والمختصين في مجال الحاسب لإتاحة فرص اكتساب خبرات عملية وتنمية مهاراتهم.",
    activities: [
      "Developing, improving, and maintaining ByTechS's digital platform.",
      "Creating the initiative's official website and ensuring its updates align with the latest technical standards.",
      "Building an environment that promotes team members' skill development.",
    ],
    activitiesAr: [
      "تطوير منصة بايتكس الرقمية وتحسين أدائها وصيانتها.",
      "إنشاء الموقع الرسمي للمبادرة وضمان تحديثه ليتماشى مع أحدث المعايير التقنية.",
      "بناء بيئة تعزز تطوير مهارات أعضاء الفريق.",
    ],
    structure: [
      "IT Project Manager: Leading the team to achieve ByTechS's technical goals.",
      "UX Designers: Designing user-friendly and attractive interfaces.",
      "Front-end Developers: Developing user interfaces and ensuring their functionality.",
      "Back-end Developers: Developing server services and managing databases.",
      "Cyber Security Specialists: Protecting technical projects from threats and ensuring data security.",
      "Technical Documentation Specialist: Preparing technical documentation and user/developer guides.",
    ],
    structureAr: [
      "قائد الفريق التقني: قيادة الفريق لتحقيق أهداف بايتكس التقنية.",
      "مصممي تجربة المستخدم: تصميم واجهات سهلة الاستخدام وجذابة للمستخدمين.",
      "مطوري الواجهة الأمامية: تطوير واجهة المستخدم وضمان عملها.",
      "مطوري الواجهة الخلفية: تطوير خدمات الخادم وإدارة قواعد البيانات.",
      "مختصي الأمن السيبراني: حماية المشاريع التقنية من التهديدات وضمان أمن البيانات.",
      "مختص التوثيق التقني: إعداد الوثائق التقنية وأدلة المستخدم والمطور.",
    ],
  },
  {
    id: 5,
    image: PR,
    title: "PR & Communication Department",
    titleAr: "قسم الاتصال الداخلي والعلاقات العامة",
    distinctive:
      "A fundamental link between internal teams and external stakeholders, fostering a culture of open communication. Integrates public relations, digital marketing, and media to present a professional and impactful image of the initiative.",
    distinctiveAr:
      "همزة وصل أساسية بين الفرق الداخلية والجهات الخارجية، تعزز ثقافة التواصل المفتوح، وتدمج بين العلاقات العامة والتسويق الرقمي والإعلام لتقديم صورة احترافية ومؤثرة عن المبادرة.",
    objective:
      "To build and activate an effective communication strategy both internally and externally that contributes to achieving the initiative's goals and enhances its presence and brand image.",
    objectiveAr:
      "بناء وتفعيل استراتيجية تواصل فعالة داخل وخارج المبادرة، تساهم في تحقيق الأهداف وتعزز من حضورها وصورتها الذهنية.",
    vision:
      "To become a leading reference in internal communication management and sustainable public relations, aligning with the initiative's aspirations and expanding its impact.",
    visionAr:
      "أن يكون الفريق مرجعًا رائدًا في إدارة الاتصال الداخلي وبناء علاقات عامة مستدامة تواكب تطلعات المبادرة وتوسّع أثرها.",
    whyUs: [
      "Enhance your skills in public relations, marketing, and digital media.",
      "Contribute to shaping the initiative's image and voice.",
      "Build a strong network internally and externally.",
      "Innovate in creating campaigns and content that showcase your impact.",
    ],
    whyUsAr: [
      "تطوير مهاراتك في العلاقات العامة، التسويق، والإعلام الرقمي.",
      "المشاركة في صنع صورة المبادرة وصوتها أمام الجمهور.",
      "بناء شبكة علاقات قوية داخل وخارج بيئة العمل.",
      "الإبداع في صناعة حملات ومحتوى يعكس أثرك وفريقك.",
    ],
    audience:
      "Internal teams and members for enhanced coordination, and external entities to develop relationships and strengthen partnerships.",
    audienceAr:
      "الفرق والأعضاء داخل المبادرة والجهات الخارجية لتطوير العلاقات وتعزيز الشراكات.",
    activities: [
      "Organize internal and external events.",
      "Prepare professional media campaigns.",
      "Develop visual and written content that reflects the initiative's identity.",
      "Document events and activities with media coverage.",
      "Manage digital platforms and boost engagement.",
    ],
    activitiesAr: [
      "تنظيم فعاليات داخلية وخارجية.",
      "إعداد حملات إعلامية احترافية.",
      "تطوير محتوى مرئي ومكتوب يعكس هوية المبادرة.",
      "توثيق الفعاليات والأنشطة وتغطيتها إعلاميًا.",
      "إدارة المنصات الرقمية ورفع مستوى التفاعل.",
    ],
    structure: [
      {
        title: "Public Relations",
        roles: [
          "External Communications Officer: Coordinates with supporters and sponsors; sends cooperation letters and represents the team officially.",
          "Documentation and Follow-up Officer: Archives partnerships and documents all external communications.",
        ],
      },
      {
        title: "Internal Communication",
        roles: [
          "Community Communication Officer: Publishes official announcements, unifies communication language, and promotes internal initiatives.",
        ],
      },
      {
        title: "HR Support",
        roles: [
          "Governance and Development Officer: Establishes and enforces internal policies.",
          "Membership and Recruitment Officer: Recruits new members and assigns them to appropriate tasks.",
          "Documentation and Support Assistant: Provides administrative support and documents meetings and outcomes.",
        ],
      },
      {
        title: "Business Development",
        roles: [
          "Business Developer: Seeks partnership opportunities that serve the team's objectives.",
          "Development Executor: Implements and monitors field partnerships and evaluates their impact.",
        ],
      },
      {
        title: "Digital Marketing",
        roles: [
          "Graphic Designer (Design): Designs fixed posts and visual identity.",
          "Motion Designer (Design): Produces animated promotional videos.",
          "Content Writer (Content): Crafts educational and awareness texts.",
          "Marketing Writer (Content): Develops advertising slogans and marketing campaigns.",
          "Photographer (Media Production): Documents events through photographs.",
          "Videographer (Media Production): Films activities and events.",
          "Video Editor (Media Production): Edits videos professionally for digital publication.",
          "TikTok Specialist (Platform Management): Creates innovative and engaging content.",
          "Instagram Specialist (Platform Management): Coordinates and designs visual content for publishing.",
          "LinkedIn Specialist (Platform Management): Produces professional content for a business audience.",
        ],
      },
    ],

    structureAr: [
      {
        title: "العلاقات العامة",
        roles: [
          "مسؤول التواصل الخارجي: ينسق مع الجهات الداعمة والرعاة؛ يرسل خطابات التعاون ويمثل الفريق رسميًا.",
          "مسؤول التوثيق والمتابعة: يؤرشف التعاونات والشراكات ويوثق كل تواصل خارجي.",
        ],
      },
      {
        title: "التواصل الداخلي",
        roles: [
          "مسؤول التواصل المجتمعي: ينشر الإعلانات الرسمية داخل الفرق، ويوحد لغة التواصل، ويروج للمبادرات الداخلية.",
        ],
      },
      {
        title: "الموارد البشرية",
        roles: [
          "مسؤول الحوكمة والتطوير: يضع السياسات الداخلية ويضمن الالتزام بها.",
          "مسؤول العضوية والاستقطاب: يستقطب أعضاء جدد ويوزعهم على المهام المناسبة.",
          "مساعد التوثيق والدعم: يدعم الفرق إداريًا ويوثق الاجتماعات والنتائج.",
        ],
      },
      {
        title: "تطوير الأعمال",
        roles: [
          "مطور الأعمال: يبحث عن فرص شراكات تخدم أهداف الفريق.",
          "منفذ التطوير: ينفذ ويتابع الشراكات ميدانيًا ويقيّم أثرها.",
        ],
      },
      {
        title: "التسويق الرقمي",
        roles: [
          "مصمم جرافيك (قسم التصميم): يصمم المنشورات الثابتة والهوية البصرية.",
          "مصمم موشن (قسم التصميم): يُعد فيديوهات ترويجية متحركة.",
          "كاتب محتوى (قسم المحتوى): يصيغ نصوصًا تعليمية وتوعوية.",
          "كاتب تسويقي (قسم المحتوى): يكتب عبارات دعائية وحملات تسويقية.",
          "مصور فوتوغرافي (قسم الإنتاج الإعلامي): يوثق الفعاليات بالصور.",
          "مصور فيديو (قسم الإنتاج الإعلامي): يصور الأنشطة.",
          "محرر فيديو (قسم الإنتاج الإعلامي): يقوم بمونتاج احترافي للنشر الرقمي.",
          "مختص تيك توك (إدارة المنصات): يبتكر محتوى إبداعي وتفاعلي.",
          "مختص إنستقرام (إدارة المنصات): ينظم وينشر ويتولى التصميم البصري.",
          "مختص لينكدإن (إدارة المنصات): ينتج محتوى احترافي للجمهور المهني.",
        ],
      },
    ],
  },
  {
    id: 6,
    image: CYS,
    title: "Cybersecurity Community",
    titleAr: "مجتمع الأمن السيبراني",

    distinctive:
      "Providing an educational and supportive environment to raise awareness of cyber threats and develop practical skills for beginners and intermediate professionals.",
    distinctiveAr:
      "يركز مجتمعنا على توفير بيئة تعليمية وداعمة لزيادة الوعي بالتهديدات السيبرانية وتطوير المهارات العملية للمبتدئين والمتوسطين.",

    objective:
      "Empower members to acquire the technical and practical skills necessary to tackle cybersecurity challenges through continuous education and specialized discussions.",
    objectiveAr:
      "تمكين الأعضاء من اكتساب المهارات الفنية والعملية لمواجهة التحديات السيبرانية من خلال التعليم المستمر والنقاشات المتخصصة.",

    vision:
      "To become the leading community in empowering cybersecurity professionals through continuous learning and collaboration with specialized institutions.",
    visionAr:
      "أن نصبح المجتمع الرائد في تمكين المحترفين في الأمن السيبراني من خلال التعليم المستمر والتعاون مع المؤسسات المتخصصة.",

    whyUs: [
      "An opportunity to learn new skills and gain practical experience from cybersecurity experts.",
      "A supportive environment that helps you develop both technical and soft skills such as leadership, communication, and problem-solving.",
      "Opportunities to build a strong professional network with experts in the field through workshops and specialized discussions.",
      "Participation in unique challenges and events that contributes to both personal and professional skill development.",
      "Ongoing support in your learning journey through advanced educational programs and recognized professional certifications.",
    ],
    whyUsAr: [
      "تعلم المهارات الجديدة واكتساب الخبرات العملية من مختصين في الأمن السيبراني.",
      "تطوير المهارات الفنية والناعمة مثل القيادة والتواصل وحل المشكلات.",
      "بناء شبكة علاقات قوية مع محترفين في المجال من خلال ورش العمل.",
      "المشاركة في تحديات وفعاليات مميزة تساعد في تطوير المهارات الشخصية والمهنية.",
      "دعم مستمر من خلال برامج تعليمية متطورة وشهادات مهنية معترف بها.",
    ],

    audience:
      "Recent graduates, individuals interested in cybersecurity, and those with beginner to intermediate experience in the field.",
    audienceAr:
      "حديثو التخرج، المهتمون بالأمن السيبراني، والمبتدئون ومتوسطو الخبرة في هذا المجال.",

    activities: [
      "Organizing hands-on workshops targeting professional certifications in cybersecurity.",
      "Hosting discussion sessions with experts to exchange knowledge.",
      "Capture the Flag challenges to enhance skills.",
      "Community awareness campaigns to raise awareness of cyber threats.",
      "Soft skills development workshops such as leadership, communication, and problem-solving.",
    ],
    activitiesAr: [
      "ورش عمل تستهدف الشهادات المهنية في مجال الأمن السيبراني.",
      "جلسات نقاشية مع مختصين لتبادل الخبرات.",
      "تحديات Capture The Flag لتعزيز المهارات.",
      "حملات توعية مجتمعية لزيادة الوعي بالتهديدات السيبرانية.",
      "ورش عمل لتطوير المهارات الناعمة مثل القيادة والتواصل.",
    ],

    structure: [
      "Community Leader: Responsible for guiding the community’s strategy and ensuring its goals are achieved.",
      "Activity Coordinator: Responsible for organizing events and workshops.",
      "Core Team Members: Support daily operations and participate in executing activities.",
    ],
    structureAr: [
      "قائد المجتمع: مسؤول عن توجيه استراتيجية المجتمع وضمان تحقيق أهدافه.",
      "منسق الأنشطة: مسؤول عن تنظيم الفعاليات والورش.",
      "أعضاء الفريق الأساسي: دعم العمليات اليومية والمشاركة في الأنشطة.",
    ],
  },
  {
    id: 7,
    image: QNTM,
    title: "Quantum Computing Community",
    titleAr: "مجتمع الحوسبة الكمية",

    distinctive:
      "A tech-development initiative in the Eastern Province aligned with Vision 2030, aiming to build a knowledge-driven community and empower national talent in future technologies—especially quantum computing, which is rapidly gaining global attention and intersecting with AI, cybersecurity, chemistry, and scientific research.",
    distinctiveAr:
      "مبادرة تقنية تنموية في المنطقة الشرقية تدعم رؤية 2030 عبر بناء مجتمع معرفي وتمكين المواهب الوطنية في التقنيات المستقبلية، خصوصًا الحوسبة الكمية التي أصبحت محور اهتمام عالمي وترتبط بالذكاء الاصطناعي والأمن السيبراني والكيمياء والبحث العلمي.",

    objective:
      "Increase awareness of quantum computing, build a connected tech community, and empower students and professionals through workshops, hackathons, and training programs while encouraging real research and local quantum projects.",
    objectiveAr:
      "رفع الوعي بالحوسبة الكمية، وبناء مجتمع تقني مترابط، وتمكين الطلبة والمهنيين من خلال الورش والهاكاثونات والبرامج التدريبية، وتشجيع المشاريع والأبحاث المحلية في المجال الكمي.",

    vision:
      "To create a leading platform that introduces and accelerates quantum computing adoption in the Eastern Province and across the Kingdom, inspiring the next generation to explore and innovate in the field.",
    visionAr:
      "أن نصبح المنصة الرائدة في المنطقة الشرقية والمملكة لتمهيد واعتماد الحوسبة الكمية، وإلهام الجيل القادم لاستكشاف هذا المجال والابتكار فيه.",

    whyUs: [
      "The Eastern Province has strong talent but lacks a dedicated quantum-focused community.",
      "ByTechs provides a flexible, youth-driven, and innovative environment ideal for launching advanced tech initiatives.",
      "Quantum computing awareness is essential before it becomes a core industry requirement.",
      "We bridge the gap between awareness, hands-on practice, and real-world applications.",
      "We offer an interdisciplinary approach linking quantum with AI, cybersecurity, chemistry, and engineering.",
    ],
    whyUsAr: [
      "المنطقة الشرقية مليئة بالمواهب لكنها تفتقر لجهة محلية متخصصة بالكوانتم.",
      "ByTechs توفر بيئة مرنة وشبابية ومبتكرة لإطلاق مبادرات تقنية متقدمة.",
      "الوعي بالحوسبة الكمية ضروري قبل أن تتحول إلى مطلب مهني أساسي.",
      "نربط بين التوعية والتطبيق العملي والتطبيقات الواقعية.",
      "نقدم نهجًا متعدد التخصصات يربط الكوانتم بالذكاء الاصطناعي والأمن السيبراني والكيمياء والهندسة.",
    ],

    whatMakesUsDifferent: [
      "Focused on the Eastern Province rather than central-only initiatives.",
      "Combines awareness with hands-on practical activities using IBM Q and Qiskit.",
      "Targets a broad audience: students, engineers, developers, researchers, and entrepreneurs.",
      "Youth-driven, flexible, and integrated with other ByTechS communities.",
      "Supports academic integration, capstone projects, and research collaborations.",
    ],
    whatMakesUsDifferentAr: [
      "يركز على المنطقة الشرقية وليس المبادرات المركزية فقط.",
      "يجمع بين التوعية والتطبيق العملي باستخدام IBM Q و Qiskit.",
      "يستهدف شريحة واسعة: طلاب، مهندسين، مطورين، باحثين، ورواد أعمال.",
      "مجتمع شبابي مرن ومتكامل مع مجتمعات ByTechS الأخرى.",
      "يدعم دمج المفاهيم في المشاريع الأكاديمية والأبحاث ومشاريع التخرج.",
    ],

    audience:
      "University students (CS, Physics, Math, Engineering), researchers, tech enthusiasts, professionals in AI/cybersecurity/cryptography, developers, and entrepreneurs.",
    audienceAr:
      "طلاب الجامعات (علوم الحاسب، الفيزياء، الرياضيات، الهندسة)، الباحثون والمهتمون بالتقنيات المستقبلية، محترفو الذكاء الاصطناعي والأمن السيبراني والتشفير، المطورون ورواد الأعمال.",

    activities: [
      "Monthly knowledge sessions on quantum topics.",
      "Quantum 101 educational series with simplified learning content.",
      "Hands-on workshops using IBM Q and Qiskit.",
      "Quantum-focused hackathons and competitions.",
      "Student-oriented quantum challenges and mini-projects.",
      "Partnerships with local universities such as IAU and KFUPM.",
      "Hosting expert speakers and researchers.",
      "Supporting capstone projects and academic research.",
    ],
    activitiesAr: [
      "جلسات شهرية معرفية حول موضوعات كوانتم.",
      "سلسلة تعليمية Quantum 101 بمحتوى مبسط.",
      "ورش عملية باستخدام IBM Q و Qiskit.",
      "هاكاثونات وتحديات موجهة لمجال الكوانتم.",
      "تحديات ومشاريع بسيطة للطلاب.",
      "شراكات مع جامعات مثل IAU و KFUPM.",
      "استضافة متحدثين وخبراء في المجال.",
      "دعم مشاريع التخرج والأبحاث.",
    ],

    structure: [
      "Community Leader: Guides strategy, partnerships, and community impact.",
      "Activity Coordinator: Organizes events, workshops, and logistics.",
      "Technical Team: Prepares quantum content, workshops, and technical materials.",
      "Core Team Members: Support operations, community engagement, and event execution.",
    ],
    structureAr: [
      "قائد المجتمع: يوجه استراتيجية المجتمع والشراكات والأثر.",
      "منسق الأنشطة: ينظم الفعاليات والورش واللوجستيات.",
      "الفريق التقني: يجهز المحتوى الكمي والورش والمواد التقنية.",
      "أعضاء الفريق الأساسي: دعم العمليات والتفاعل المجتمعي وتنفيذ الأنشطة.",
    ],
  },

  //   {
  //     id: 5,
  //     image: FinancialProducts,
  //     title: "",
  //     titleAr: "",
  //     distinctive: "",
  //     distinctiveAr: "",
  //     objective: "",
  //     objectiveAr: "",
  //     vision: "",
  //     visionAr: "",
  //     whyUs: ["", "", "", "", ""],
  //     whyUsAr: ["", "", "", "", ""],
  //     audience: "",
  //     audienceAr: "",
  //     activities: ["", "", "", "", ""],
  //     activitiesAr: ["", "", "", "", ""],
  //     structure: ["", "", "", "", ""],
  //     structureAr: ["", "", "", "", ""],
  //   },
  //   {
  //     id: 6,
  //     image: Sustainability,
  //     title: "",
  //     titleAr: "",
  //     distinctive: "",
  //     distinctiveAr: "",
  //     objective: "",
  //     objectiveAr: "",
  //     vision: "",
  //     visionAr: "",
  //     whyUs: ["", "", "", "", ""],
  //     whyUsAr: ["", "", "", "", ""],
  //     audience: "",
  //     audienceAr: "",
  //     activities: ["", "", "", "", ""],
  //     activitiesAr: ["", "", "", "", ""],
  //     structure: ["", "", "", "", ""],
  //     structureAr: ["", "", "", "", ""],
  //   },
];

export default CommunitiesData;
